import React from 'react';
import { Card } from '@/components/ui/card';
import { Users, User, ChevronRight } from 'lucide-react';

export default function CustomerList({ customers, filteredCustomers, onSelect }) {
  if (filteredCustomers.length === 0) {
    return (
      <Card className="p-8 text-center">
        <Users className="w-16 h-16 mx-auto mb-4 text-muted-foreground/50" />
        <p className="text-muted-foreground">
          {customers.length === 0
            ? 'No customers yet'
            : 'No customers match your search'}
        </p>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {filteredCustomers.map(customer => (
        <Card
          key={customer.id}
          className="p-4 cursor-pointer hover:shadow-lg transition-all"
          onClick={() => onSelect(customer)}
          data-testid="customer-card"
        >
          <div className="flex items-start gap-3">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
              customer.type === 'registered' ? 'bg-green-100' : 'bg-blue-100'
            }`}>
              <User className={`w-5 h-5 ${
                customer.type === 'registered' ? 'text-green-600' : 'text-blue-600'
              }`} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                {/* Red dot before the name for inactive customers.
                    Subtle scannable indicator alongside the existing
                    User/Guest pill. Greys out the name colour too so
                    the row reads as "muted". */}
                {customer.account_status === 'inactive' && (
                  <span
                    className="w-2 h-2 rounded-full bg-rose-500 shrink-0"
                    title="Account inactive"
                    aria-label="Inactive customer"
                    data-testid="inactive-customer-dot"
                  />
                )}
                <h3
                  className={`font-bold truncate ${
                    customer.account_status === 'inactive' ? 'text-slate-500' : ''
                  }`}
                >
                  {customer.name}
                </h3>
                <span className={`text-xs px-1.5 py-0.5 rounded-full ${
                  customer.type === 'registered'
                    ? 'bg-green-100 text-green-700'
                    : 'bg-blue-100 text-blue-700'
                }`}>
                  {customer.type === 'registered' ? 'User' : 'Guest'}
                </span>
              </div>
              <p className="text-sm text-muted-foreground truncate">
                {customer.phone || customer.email || 'No contact info'}
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                {customer.booking_count} booking{customer.booking_count !== 1 ? 's' : ''}
              </p>
            </div>
            <ChevronRight className="w-5 h-5 text-muted-foreground flex-shrink-0" />
          </div>
        </Card>
      ))}
    </div>
  );
}
